<template>
  <div>
    <b-row>
      <b-col>
        <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </b-col>
    </b-row>
    <h2>Registros de Despesas</h2>
    <div>
      <router-link :to="`/checklist/expense/save/`">
        <b-button size="sm">
          {{ $t("expense.expenseCreate") }}
        </b-button>
      </router-link>
      <!-- <b-button
        size="sm"
        class="ml-2 btn-checklist cleanFilters"
        @click="filtersClean"
      >
        {{ $t("geral.cleanFilters") }}
      </b-button> -->

      <b-table
        ref="expenseTable"
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        current-page="0"
        :filter.sync="tableFilters"
        :filter-debounce="500"
        :responsive="true"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th
              v-for="field in fields"
              :key="field.filterKey"
              class="vertical-align"
            >
              <div v-if="field.filterKey != 'actions'">
                <b-form-select
                  v-if="field.filterKey == 'active'"
                  v-model="tableFilters[field.filterKey]"
                  :options="optionsBoolean"
                />
                <b-form-select
                  v-else-if="field.filterKey == 'expenseType'"
                  v-model="tableFilters[field.filterKey]"
                  :options="expenseTypeOpt"
                />
                <b-form-select
                  v-else-if="field.filterKey == 'apportionment'"
                  v-model="tableFilters[field.filterKey]"
                  :options="apportionmentOpt"
                />
                <b-form-select
                  v-else-if="field.filterKey == 'typeOfApportionment'"
                  v-model="tableFilters[field.filterKey]"
                  :options="typeOfApportionmentOpt"
                />
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                  class="idStyle"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(actions)="data">
          <router-link :to="'/checklist/expense/save/' + data.item.id">
            <b-button size="sm">{{ $t("geral.edit") }}</b-button>
          </router-link>
          <b-button
            v-if="data.item.active"
            variant="danger"
            class="ml-2"
            size="sm"
            @click="toggleActiveState(data.item.id)"
            >Desativar</b-button
          >
          <b-button
            v-else
            size="sm"
            @click="toggleActiveState(data.item.id)"
            class="ml-2"
            >Ativar</b-button
          >
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpenseList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Despesa salva com sucesso",
      },
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          thStyle: "width: 110px",
        },
        {
          key: "description",
          filterKey: "description",
          sortable: false,
          label: "Descrição",
          thStyle: "width: 110px",
        },
        {
          key: "expenseType",
          filterKey: "expenseType",
          sortable: false,
          label: "Tipo da despesa",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Variável";
            }
            return "Fixa";
          },
        },
        // {
        //   key: "value",
        //   filterKey: "value",
        //   sortable: false,
        //   label: "Valor",
        //   thStyle: "width: 110px",
        // },
        {
          key: "apportionment",
          filterKey: "apportionment",
          sortable: false,
          label: "Rateio",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Diário";
            } else if (value == 2) {
              return "Semanal";
            } else if (value == 3) {
              return "BiSemanal";
            } else if (value == 4) {
              return "Mensal";
            } else if (value == 5) {
              return "Anual";
            }
            return "";
          },
        },
        {
          key: "typeOfApportionment",
          filterKey: "typeOfApportionment",
          sortable: false,
          label: "Tipo do rateio",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Veículo";
            } else if (value == 2) {
              return "Motorista";
            }
            return "";
          },
        },
        {
          key: "active",
          filterKey: "active",
          sortable: false,
          label: "Ativo",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: {
        description: "",
        expenseType: 0,
        apportionment: 0,
        typeOfApportionment: 0,
        active: true,
      },
      optionsBoolean: [
        { value: null, text: "Todos" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      expenseTypeOpt: [
        { value: 0, text: "" },
        { value: 1, text: "Variável" },
        { value: 2, text: "Fixa" },
      ],
      apportionmentOpt: [
        { value: 0, text: "" },
        { value: 1, text: "Diário" },
        { value: 2, text: "Semanal" },
        { value: 3, text: "BiSemanal" },
        { value: 4, text: "Mensal" },
        { value: 5, text: "Anual" },
      ],
      typeOfApportionmentOpt: [
        { value: 0, text: "" },
        { value: 1, text: "Veiculo" },
        { value: 2, text: "Motorista" },
      ],
      tableItems: [],
      isBusy: false,
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [10, 25, 50, 100, 150],
    };
  },
  methods: {
    myProvider(ctx, callback) {
      let apiFilter = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        description: ctx.filter.description,
        expenseType: ctx.filter.expenseType,
        apportionment: ctx.filter.apportionment,
        typeOfApportionment: ctx.filter.typeOfApportionment,
        active: ctx.filter.active,
      };
      this.$apiVehicle
        .post("/expense/getAll/", apiFilter)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            callback([]);
          }
        });
      return null;
    },
    toggleActiveState(expenseId) {
      this.$apiVehicle
        .post("/expense/ToggleActiveState/" + expenseId)
        .then((response) => {
          this.$refs.expenseTable.refresh();
          this.$forceUpdate();
          this.$refs.successFadeAlert.show();
        })
        .catch((error) => {
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    // Lifecycle hook
  },
};
</script>

<style scoped>
/* Your styles here */
</style>